import { render, staticRenderFns } from "./InstanceView.vue?vue&type=template&id=a4060c7c&scoped=true"
import script from "./InstanceView.vue?vue&type=script&lang=js"
export * from "./InstanceView.vue?vue&type=script&lang=js"
import style0 from "./InstanceView.vue?vue&type=style&index=0&id=a4060c7c&prod&scoped=true&lang=css"
import style1 from "./InstanceView.vue?vue&type=style&index=1&id=a4060c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4060c7c",
  null
  
)

export default component.exports